/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Kind_FreebsdInputs */

const en_fc_dl_kind_freebsd = /** @type {(inputs: Fc_Dl_Kind_FreebsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FreeBSD tarball`)
};

/**
* | output |
* | --- |
* | "FreeBSD tarball" |
*
* @param {Fc_Dl_Kind_FreebsdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_kind_freebsd = /** @type {((inputs?: Fc_Dl_Kind_FreebsdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Kind_FreebsdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_kind_freebsd(inputs)
});
export { fc_dl_kind_freebsd as "fc.dl.kind.freebsd" }